import { ShieldCheck } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { IndustryBento } from "../components/site/IndustryBento";
import { Reveal } from "../components/site/Reveal";
import { CtaBand } from "../components/site/CtaBand";
import { useSeo } from "../lib/useSeo";

export default function Industries() {
  useSeo("Branchen und Berufe", "Logistik, Handwerk, Industrie, Gesundheit und Pflege, Gastronomie, Gebäudeservice und Verwaltung: Für diese Branchen vermittelt PACTORA Arbeitskräfte aus dem Ausland.", "/branchen");
  return (
    <>
      <PageHero testid="industries-hero" eyebrow="Branchen und Berufe" lines={["Viele Berufe.", "Ein sorgfältiger Abgleich."]}
        intro="Wir vermitteln Arbeitskräfte aus dem Ausland in unterschiedliche Branchen. Für jede Anfrage prüfen wir, ob Qualifikation, Erfahrung und Sprachkenntnisse zu Ihren Anforderungen passen." />
      <section className="bg-white pb-24 md:pb-32" data-testid="industries-grid">
        <div className="container-x">
          <IndustryBento detailed />
          <Reveal>
            <div className="mt-12 grid gap-6 rounded-[2rem] bg-[color:var(--mist)] p-8 md:grid-cols-12 md:p-12">
              <ShieldCheck size={36} className="text-[color:var(--teal-ink)] md:col-span-1" />
              <div className="md:col-span-11 space-y-3 text-slate-700 leading-relaxed">
                <h2 className="text-xl font-bold text-[color:var(--navy)]">Hinweis zu reglementierten Berufen</h2>
                <p>Für reglementierte Berufe – etwa Ärztinnen und Ärzte, Pflegefachkräfte und weitere Gesundheitsberufe – sind vor der eigenständigen Berufsausübung eine Anerkennung bzw. Berufszulassung und oft bestimmte Sprachnachweise erforderlich. Auch in anderen Berufen kann eine Gleichwertigkeitsprüfung des ausländischen Abschlusses nötig sein, zum Beispiel für das Visum.</p>
                <p>Die tatsächliche Vermittlung richtet sich nach Bewerberverfügbarkeit, Ihren Anforderungen und den rechtlichen Voraussetzungen im Einzelfall.</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
